import cx from 'classnames';
import React from 'react';
import { BaseTab } from '../base-tab';
import styles from './tab.module.scss';
export const Tab = ({ children, verticalLayoutTabsPlacement = 'left', selectedTabId = '', className = '', ...restProps }) => {
    const tabHeaderClass = cx(styles.tabVertical, className);
    return (React.createElement("div", { className: cx(styles.tabContainer, styles[verticalLayoutTabsPlacement]), ...restProps }, BaseTab(children, selectedTabId, styles, tabHeaderClass)));
};
//# sourceMappingURL=tab.js.map